import { FC, useState } from "react";
import useStore from "../../../../../../helpers/useStore";
import { useMasterTables } from "../../../../../../stores/MasterTables";
import { Grid } from "@mui/material";
import BillBoxWrapper from "../../../DirectBilling/common/components/BillBoxWrapper";
import { TopLevelPaper } from "../../../../../../themes/StyledComponents";
import CopaymentBillInfo from "../components/CopaymentBillInfo";
import TransactionRxOverview from "../../../Base/components/TransactionRxOverview";

interface CopaymentFullScreenBillProps {
  handleFullScreenDialogClose: () => void;
  selectedAccount: string;
  userName: string;
  userId: string;
}

const CopaymentFullScreenBill: FC<CopaymentFullScreenBillProps> = ({
  handleFullScreenDialogClose,
  selectedAccount,
  userName,
  userId,
}) => {
  const [selectedRx, setSelectedRx] = useState<any>(null);
  const [isVisible, setIsVisible] = useState(false);
  const { data: masterTablesData } = useMasterTables();
  const [editRxMode, setEditRxMode] = useState<boolean>(false);

  const handleRxDelete = (deletedRxId: string) => {
    if (selectedRx && selectedRx.id === deletedRxId) {
      setSelectedRx(null);
      setIsVisible(false);
    }
  };

  const handleRowClick = (rx: any) => {
    setSelectedRx(rx);
    setIsVisible(true);
  };

  const handleValidationFilter = (remainingRxs: any[]) => {
    // Check if the selected RX is no longer in the list of remaining RXs
    if (selectedRx && !remainingRxs.some((rx) => rx.id === selectedRx.id)) {
      setSelectedRx(null);
      setIsVisible(false);
    }
  };

  return (
    <Grid
      container
      spacing={1}
      sx={{ height: "100%", marginTop: "1px" }}
    >
      <BillBoxWrapper xs={5}>
        <TopLevelPaper
          className="scrollable rounded-container"
          sx={{ paddingTop: "0px" }}
        >
          {/* Pass handleRowClick to BillInfo */}
          <CopaymentBillInfo
            handleFullScreenDialogClose={handleFullScreenDialogClose}
            onRowClick={handleRowClick}
            account={selectedAccount}
            userName={userName}
            userId={userId}
            onRxDelete={handleRxDelete}
            onValidationFilter={handleValidationFilter}
          />
        </TopLevelPaper>
      </BillBoxWrapper>
      {isVisible && (
        <>
          <BillBoxWrapper xs={7}>
            <TopLevelPaper className="scrollable rounded-container">
              {/* Pass the selected rx to BillOverview */}
              <TransactionRxOverview
                rowData={selectedRx}
                masterData={masterTablesData}
                editRxMode={editRxMode}
                setEditRxMode={setEditRxMode}
              />
            </TopLevelPaper>
          </BillBoxWrapper>
        </>
      )}
    </Grid>
  );
};

export default CopaymentFullScreenBill;
